import api from './api';

// Create a Razorpay order for a booking
export const createPayment = async (bookingId) => {
  const { data } = await api.post(`/vehicle/vehicle-booking/${bookingId}/payment`);
  return data;
};

// Verify payment after Razorpay returns
export const verifyPayment = async (payload) => {
  const { data } = await api.post(
    '/vehicle/vehicle-booking/payment/verify',
    payload
  );
  return data;
};

// Load Razorpay checkout script once
export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });